const fileUpload = {
  'file-upload.upload': 'Загрузить файл с ...',
  'file-upload.uploading': 'Загрузка...',
  'file-upload.success': 'Файл загружен успешно',
  'file-upload.error': 'Файл загружен не успешно',
  'file-upload.error.message': 'Файл загружен не успешно',
  'file-upload.formatHint': 'Поддерживаемые форматы: {accept}',
  'file-upload.sizeHint.max': 'Максимальный размер файла: {maxSize}Mb',
  'file-upload.countLimit': 'Максимальное количество файлов: {maxCount}',
  'file-upload.singleFile': 'Можно загрузить только один файл',
};

export default fileUpload;
